
export class ErrorCopyConfig {

    constructor(platform,lang = "en"){
        this.platform = platform;
        this.lang = lang;
    }

    getErrorCopy(){
        return {
            "category": "error copy",
            "enabled": true,
            "params": {
                "templates": {
                    "error": "<br><br>Error Code: {ERROR_CODE}"
                },
                "style": {
                    "url": {
                        "color": "#0099FF !important"
                    }
                },
                "url": this.getUrls(), 
                "message": this.getMessages(), 
                "map": this.getMap()
            }
        }
    }

    getUrls(){
        switch(this.platform){
            case "PPLUS" :
                return {
                    "1": {
                        "copy": "here",
                        "url": "http://help.paramountplus.com/",
                        "target": "_blank", 
                        "refreshPage": false
                    },
                    "2": {
                        "copy": "help.paramountplus.com/",
                        "url": "http://help.paramountplus.com/",
                        "target": "_blank",
                        "refreshPage": false
                    },
                    "3": {
                        "copy": "Return home",
                        "url": "https://www.paramountplus.com/home/",
                        "target": "_self",
                        "refreshPage": false
                    },
                    "4": {
                        "copy": "FAQ",
                        "url": "http://help.paramountplus.com/",
                        "target": "_blank",
                        "refreshPage": false
                    },
                    "5": {
                        "copy": "Try again",
                        "url": "",
                        "target": "_self",
                        "refreshPage": true
                    },
                    "6": {
                        "copy": "Paramount Plus Sign Up",
                        "url": "https://www.paramountplus.com/account/signup/plan",
                        "target": "_self",
                        "refreshPage": false
                    },
                    "7": {
                        "copy": "Paramount Plus Sign Up",
                        "url": "https://www.paramountplus.com/account/signup/plan",
                        "target": "_self",
                        "refreshPage": false
                    },
                    "DEFAULT": {
                        "copy": "here",
                        "url": "http://help.paramountplus.com/",
                        "target": "_blank",
                        "refreshPage": false
                    }
                }
            default:
                return {
                    "1": {
                        "copy": "here",
                        "url": "https://help.cbs.com/s/",
                        "target": "_blank", 
                        "refreshPage": false
                    },
                    "2": {
                        "copy": "cbs.com/vpnhelp",
                        "url": "https://help.cbs.com/s/",
                        "target": "_blank",
                        "refreshPage": false
                    },
                    "3": {
                        "copy": "Return home",
                        "url": "https://www.cbs.com/",
                        "target": "_self",
                        "refreshPage": false
                    },
                    "4": {
                        "copy": "FAQ",
                        "url": "https://help.cbs.com/s/",
                        "target": "_blank",
                        "refreshPage": false
                    },
                    "5": {
                        "copy": "Try again",
                        "url": "",
                        "target": "_self",
                        "refreshPage": true
                    },
                    "6": {
                        "copy": "CBS All Access Commercial Free",
                        "url": "https://help.cbs.com/s/",
                        "target": "_self",
                        "refreshPage": false
                    },
                    "7": {
                        "copy": "CBS All Access Commercial Free",
                        "url": "https://help.cbs.com/s/",
                        "target": "_self",
                        "refreshPage": false
                    },
                    "DEFAULT": {
                        "copy": "here",
                        "url": "https://help.cbs.com/s/",
                        "target": "_blank",
                        "refreshPage": false
                    }
                }
        }
    }

    getMessages(){
        switch(this.lang){
            default:
                return {
                    "1": {
                        "copy": "Sorry, this video is currently unavailable. Please try again.<br><br>Need additional help? Check out our troubleshooting tips {URL}", 
                        "urlId": "1", 
                        "addError": true
                    },
                    "2": {
                        "copy": "Oh no! It looks like you’re using a VPN or proxy, which prevents playing your video. Please disable this service and try again.<br><br>Need help? Visit {URL}",
                        "urlId": "2",
                        "addError": true
                    },
                    "3": {
                        "copy": "Sorry, but due to licensing restrictions, this video isn’t available in your location. {URL}",
                        "urlId": "3",
                        "addError": true
                    },
                    "4": {
                        "copy": "OOPS! We're having some trouble playing this video. Please try again. If you continue to experience issues, check your internet connection or restart your router.<br><br>Need help? Visit our {URL}",
                        "urlId": "4",
                        "addError": true
                    },
                    "5": {
                        "copy": "Oh no! This video can't be played right now. Please disable any ad-blocking software and try again.<br><br>Need help? Visit our {URL}",
                        "urlId": "4",
                        "addError": true
                    },
                    "6": {
                        "copy": "OOPS! Looks like the internet may be experiencing some issues. Please check your connection and try again. If you continue to experience issues, try restarting your router.<br><br>{URL}",
                        "urlId": "5",
                        "addError": true
                    },
                    "100": {
                        "copy": "Oops! This video is not supported on your web browser.<br><br>To continue streaming, we recommend using the latest version of Chrome or Firefox.",
                        "addError": true
                    },
                    "110": {
                        "copy": "Sorry, this video is currently unavailable.<br>Please refresh your page or try again later.",
                        "addError": true
                    },
                    "111": {
                        "copy": "This video is unavailable because we were unable to load a message from our sponsors.</br>If you are using ad blocking software please disable it and reload the page",
                        "addError": true
                    },
                    "112": {
                        "copy": "This video is unavailable because we were unable to load a message from our sponsors.<br><br>Please exit private mode and reload the page to continue watching.",
                        "addError": true
                    },
                    "113": {
                        "copy": "This video is unavailable because we were unable to load a message from our sponsors.<br><br>If you are using ad blocking software please disable it and reload the page. Or subscribe to {URL} to watch your favorite CBS shows and videos without commercials!",
                        "urlId": "6",
                        "addError": true
                    },
                    "114": {
                        "copy": "This video is unavailable because we were unable to load a message from our sponsors.<br><br>If you are using ad blocking software please disable it and reload the page. Or upgrade to {URL} to watch your favorite CBS shows and videos without commercials!",
                        "urlId": "7",
                        "addError": true
                    },
                    "121": {
                        "copy": "Sorry, this video is currently unavailable.<br>Please refresh your page or try again later.",
                        "addError": true
                    },
                    "122": {
                        "copy": "Sorry, this video is currently unavailable.<br>Please refresh your page or try again later.",
                        "addError": true
                    },
                    "200": {
                        "copy": "Sorry, this video is currently unavailable.<br>Please refresh your page or try again later.",
                        "addError": true
                    },
                    "OFFLINE": {
                        "copy": "Oops, looks like you’re not connected to the internet.<br>Please check your connection and try again.",
                        "addError": true
                    },  
                    "DEFAULT": {
                        "copy": "Sorry, this video is currently unavailable. Please try again.<br><br>Need additional help? Check out our troubleshooting tips {URL}",
                        "urlId": "1",
                        "addError": true
                    }
                }
        }
    }

    getMap(){
        return {
            "100": "100", 
            "110": "110", 
            "111": "111", 
            "112": "112",
            "113": "113", 
            "114": "114", 
            "120": "110",
            "121": "110",
            "122": "110",  
            "123": "110", 
            "200": "110",  
            "1000": "1",
            "1100": "1",
            "1101": "3",
            "1102": "2",
            "1103": "2",
            "1104": "2",
            "1105": "1",
            "1106": "1",
            "1200": "5",
            "1201": "5",
            "1202": "1",
            "1203": "1",
            "2000": "1",
            "2100": "1",
            "2200": "1",
            "2300": "1",
            "3001": "4",
            "3002": "4",
            "3003": "4",
            "3004": "4",
            "3100": "4",
            "3101": "4",
            "3102": "4",
            "3103": "4",
            "3104": "4",
            "3200": "4",
            "3201": "4",
            "3202": "4",
            "3203": "4",
            "3204": "4",
            "3300": "4",
            "3301": "4",
            "3302": "4",
            "3303": "4",
            "3304": "4",
            "3400": "4",
            "3401": "4",
            "3402": "4",
            "3403": "4",
            "4000": "1",
            "4100": "1",
            "4101": "1",
            "4200": "1",
            "4201": "1",
            "4300": "5",
            "9999": "4", 
            "DEFAULT": "1"
        }
    }
}